module.exports = __webpack_public_path__ + "img/image39.759b9890.jpg";